import { Navigate, Route, Routes } from 'react-router-dom';

import {
  Login,
  Condominiums,
  Condominium,
  ForgotPassword,
  Lockers,
  Garments,
  Laundries,
  Persons,
  Person,
  Contractors,
  Terms,
  Shops,
  Markets,
  ShopGroups,
} from '../pages';

import { CondominiumProvider } from '../contexts/CondominiumContext';
import { PersonProvider } from '../contexts/PersonContext';
import PrivateRoute from './PrivateRoute';
import { ShopProvider } from '../contexts/ShopContext';
import Shop from '../pages/Shop';
import { ShopGroupProvider } from '../contexts/ShopGroupContext';
import { MarketProvider } from '../contexts/MarketContext';
import Market from '../pages/Market';
import ShopGroup from '../pages/ShopGroup';

const CondominiumsRoutes = (): JSX.Element => (
  <CondominiumProvider>
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute title="Condomínios">
            <Condominiums />
          </PrivateRoute>
        }
      />

      <Route
        path="/:id/*"
        element={
          <PrivateRoute title="Condomínio">
            <Condominium />
          </PrivateRoute>
        }
      />
    </Routes>
  </CondominiumProvider>
);

const PersonsRoutes = (): JSX.Element => (
  <PersonProvider>
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute title="Pessoas">
            <Persons />
          </PrivateRoute>
        }
      />

      <Route
        path="/:id/*"
        element={
          <PrivateRoute title="Pessoa">
            <Person />
          </PrivateRoute>
        }
      />
    </Routes>
  </PersonProvider>
);

const MarketsRoutes = (): JSX.Element => (
  <MarketProvider>
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute title="Mercados">
            <Markets />
          </PrivateRoute>
        }
      />

      <Route
        path="/:id/*"
        element={
          <PrivateRoute title="Mercado">
            <Market />
          </PrivateRoute>
        }
      />
    </Routes>
  </MarketProvider>
);

const ShopsRoutes = (): JSX.Element => (
  <ShopProvider>
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute title="Lojas">
            <Shops />
          </PrivateRoute>
        }
      />

      <Route
        path="/:id/*"
        element={
          <PrivateRoute title="Loja">
            <Shop />
          </PrivateRoute>
        }
      />
    </Routes>
  </ShopProvider>
);

const ShopGroupRoutes = (): JSX.Element => (
  <ShopGroupProvider>
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute title="Grupo de Lojas">
            <ShopGroups />
          </PrivateRoute>
        }
      />
      <Route
        path="/:id/*"
        element={
          <PrivateRoute title="Grupo de Loja">
            <ShopGroup />
          </PrivateRoute>
        }
      />
    </Routes>
  </ShopGroupProvider>
);

export default function MainRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/condominiums" />} />
        <Route path="/persons/*" element={<PersonsRoutes />} />
        <Route path="/shops/*" element={<ShopsRoutes />} />
        <Route path="/shop-groups/*" element={<ShopGroupRoutes />} />
        <Route path="/condominiums/*" element={<CondominiumsRoutes />} />
        <Route path="/markets/*" element={<MarketsRoutes />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/laundries/*">
          <Route
            element={
              <PrivateRoute title="Lavanderias">
                <Laundries />
              </PrivateRoute>
            }
            index
          />

          <Route
            path=":id/garments"
            element={
              <PrivateRoute title="Lavanderias">
                <Garments />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="/lockers"
          element={
            <PrivateRoute title="Armários">
              <Lockers />
            </PrivateRoute>
          }
        />

        <Route
          path="/contractors"
          element={
            <PrivateRoute title="Parceiros">
              <Contractors />
            </PrivateRoute>
          }
        />

        <Route
          path="/terms"
          element={
            <PrivateRoute title="Termos">
              <Terms />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
}
